export default __webpack_public_path__ + "static/female-laugh-89d180b84aa99a16b6d0e93d01b2b1cb.mp3";